import React, {Suspense} from "react";
import {Switch, Route, BrowserRouter, Redirect, HashRouter} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import './assets/styles/fww.css';
import Main from "./publish/main/mainRoutes";
import Admin from "./publish/admin/AdminRoutes";
import Example from "./publish/example/ExamRoutes";
import CookieUtil from "./utils/CookieUtil";
import ModalComponent from 'publish/modal/ModalComponent'
import PageLoading from "./components/loading";
import ErrorPage from "./components/error/ErrorPage";
import PopupUtil from "./utils/PopupUtil";
import CommonModalComponent from "./publish/modal/CommonPopupComponent";
import configStore from "common/config/store/ConfigStore";
import {useCookies} from "react-cookie";
import SysError from "./components/error/SysError";
import {ErrorBoundary} from "react-error-boundary";

function App() {
    const [cookie, setCookie, removeCookie] = useCookies();
    const [systemMode, setSystemMode] = React.useState<string>();
    const [loadedIbSheet, setLoadedIbSheet] = React.useState(false);
    CookieUtil.initialize(cookie, setCookie, removeCookie);
    PopupUtil.initialize();

    React.useEffect(() => {
        CookieUtil.setCookies(cookie);
        setSystemMode(configStore.config.systemMode);

        if(window.IBSheet && !loadedIbSheet) {
            window.IBSheet.CommonOptions.Cfg.Down2ExcelConfig = {
                        excelFontSize:10,
                        excelRowHeight:-1,
                        wordWrap:0,
            }
            window.IBSheet.CommonOptions.Cfg.Height = "737px";
            setLoadedIbSheet(true);
        }
    })

    return (
        <Suspense fallback={<PageLoading/>}>
            <ErrorBoundary fallback={<SysError/>}>
                <BrowserRouter>
                    <Switch>
                        <Redirect exact from="/" to="/main/user_main"/>
                        <Route path="/main" render={() => <Main/>}/>
                        <Route path="/admin" render={() => <Admin/>}/>
                        {systemMode !== "real" && <Route path="/example" render={() => <Example/>}/>}
                        <Route path={"*"} render={() => <ErrorPage/>}/>
                    </Switch>
                </BrowserRouter>
            </ErrorBoundary>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                draggable={false}
                hideProgressBar
                newestOnTop
                closeOnClick
                pauseOnHover
            />
            <CommonModalComponent/>
            <ModalComponent/>
        </Suspense>
    );
}

export default App;